module.exports = __webpack_public_path__ + "static/img/wxcode.22aaee31.jpg";